
function get_options(lang) {
    if (lang== 'fr') {
        return {
            title: '&#x1F36A; RGPD & cookies !',
            message: "Ce site n'utilise pas de cookies marketing, n'héberge aucune publicité, ne stocke et n'exporte aucune information personnelle non nécessaire à son objet commercial primaire. Il est donc naturellement conforme aux obligations RGPD et nous n'avons pas d'option supplémentaire à vous proposer.<br>",
            delay: 600,
            expires: 30,
            link: '/vb_blog/infos/vos-donnees-personnelles/',
            onAccept: function(){
                var myPreferences = $.fn.ihavecookies.cookie();
                console.log('Yay! The following preferences were saved...');
                console.log(myPreferences);
            },
            uncheckBoxes: true,
            acceptBtnLabel: "D'accord!",
            advancedBtnLabel: "Catégories de cookies",
            moreInfoLabel: 'Notre politique RGPD',
            cookieTypesTitle: "Nous ne posons aucun cookie non essentiel<br>(voir notre politique GDPR pour plus d'information)",
            fixedCookieTypeLabel: 'Cookies essentiel',
            fixedCookieTypeDesc: 'Cookies indispensables pour le fonctionnement du site.',
            cookiesTypes: []
        };
    }
    return {
        title: '&#x1F36A; GDPR & cookies',
        message: 'This site uses no marketing cookies, hosts zero advertisements, stores and exports no personal information that is not necessary for its primary commercial function. It is therefore naturally compliant with GDPR obligations, and we have no other option to propose.<br>',
        delay: 600,
        expires: 30,
        link: '/vb_blog/en/infos-en/protection-personal-information/',
        onAccept: function(){
            var myPreferences = $.fn.ihavecookies.cookie();
            console.log('Yay! The following preferences were saved...');
            console.log(myPreferences);
        },
        uncheckBoxes: true,
        acceptBtnLabel: 'I understand !',
        advancedBtnLabel: 'Cookie categories',
        moreInfoLabel: 'Our GDPR policy',
        cookieTypesTitle: "We are not setting any non-essential cookie<br>(see ou GDPR policy for more information)",
        fixedCookieTypeLabel: 'Essential cookies',
        fixedCookieTypeDesc: 'These are essential for the website to work correctly.',
        cookieTypes: []
    };
}

$(document).ready(function() {
    const lang = $('html').attr('lang');
    const options = get_options(lang);
    $('body').ihavecookies(options);

    if ($.fn.ihavecookies.preference('marketing') === true) {
        console.log('This should run because marketing is accepted.');
    }

    $('#ihavecookiesBtn').on('click', function(){
        $('body').ihavecookies(options, 'reinit');
    });
});
